import QuickAdd from '../global/QuickAdd';
import Section from '../Section';

export default class RecentlyViewed extends Section {

  /**
   * @param {import('../ThemeBase').default} theme
   * @param {HTMLElement} element
   */
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.element = element;
    this.wrapper = this.element.closest('[data-recently-viewed-wrapper]');

    this.addEventListeners();
  }

  addEventListeners() {
    window.eventBus.on('recentlyViewed:updated', this.onRecentlyViewedUpdated.bind(this));
  }

  onRecentlyViewedUpdated() {
    this.show();
  }

  show = () => {
    this.wrapper.style.display = 'block';
    this.quickAddButtons = new QuickAdd(this.theme, this.element);
    this.badge = this.theme.addBadges(this.element, 1000);

    const sectionLoadedEvent = new CustomEvent('theme:section:load');
    document.dispatchEvent(sectionLoadedEvent);

    const recentlyViewedLoadedEvent = new CustomEvent('recentlyViewed:loaded');
    document.dispatchEvent(recentlyViewedLoadedEvent);
  }

  onUnload() {
    window.eventBus.off('recentlyViewed:updated', this.onRecentlyViewedUpdated);
  }
}
